import { FlexBox } from '../box';
import { Button } from '../button';
import { styled } from '../styled';
export const StyledBarContainer = styled(FlexBox)(({ theme }) => ({
    backgroundColor: theme.components?.['language-picker']?.background?.enabled,
    width: '100%',
    height: 48,
    paddingTop: theme.spacing(0.75),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(0.75),
    paddingLeft: theme.spacing(3),
    justifyContent: 'space-between',
    alignItems: 'center'
}));
export const StyledMenuButton = styled(Button)(({ theme, $isDisabled, $isOpen }) => ({
    cursor: $isDisabled ? 'not-allowed' : 'pointer',
    ...($isDisabled
        ? {
            color: theme.palette.text.disabled,
            backgroundColor: theme.palette.action.disabledBackground
        }
        : {
            color: theme.components?.['language-picker']?.contrast?.text,
            backgroundColor: $isOpen
                ? theme.components?.['language-picker']?.background?.focus
                : theme.components?.['language-picker']?.background
                    ?.enabled,
            '&:hover': {
                backgroundColor: theme.components?.['language-picker']?.background
                    ?.hover
            }
        })
}));
